import { twMerge } from 'tailwind-merge';
import Button from '~/components/Button';
import Icon from '~/components/Icon';
import type { Pagination } from './usePagination';

type PaginationControlsProps = Pagination & {
  className?: string;
  loop?: boolean;
};

export default function PaginationControls({
  currentPage,
  pageCount,
  next: onNext,
  hasNext,
  previous: onPrevious,
  hasPrevious,
  loop = false,
  className,
}: PaginationControlsProps) {
  if (pageCount < 2) return null;

  return (
    <nav
      aria-label="Pagination"
      className={twMerge('flex items-center text-sm', className)}
    >
      <Button
        variant="icon"
        className="border-none shadow-none"
        onClick={onPrevious}
        aria-label="View Previous Page"
        disabled={!loop && !hasPrevious}
      >
        <Icon icon="ArrowLeft" title="Previous Page" />
      </Button>
      <span className="w-24 text-center text-gray-800">
        {`${currentPage} / ${pageCount}`}
      </span>
      <Button
        variant="icon"
        type="button"
        className="border-none shadow-none"
        onClick={onNext}
        aria-label="View Next Page"
        disabled={!loop && !hasNext}
      >
        <Icon icon="ArrowRight" title="Next Page" />
      </Button>
    </nav>
  );
}
